const EVENT_ERROR_CODE = {
  EVENT_001: 'EVENT001',
  EVENT_002: 'EVENT002',
  EVENT_003: 'EVENT003',
  EVENT_004: 'EVENT004',
  EVENT_005: 'EVENT005',
  EVENT_006: 'EVENT006',
  EVENT_007: 'EVENT007',
  EVENT_008: 'EVENT008',
  EVENT_009: 'EVENT009',
  EVENT_010: 'EVENT010',
  EVENT_011: 'EVENT011',
  EVENT_012: 'EVENT012',
  EVENT_013: 'EVENT013',
  EVENT_014: 'EVENT014',
  EVENT_015: 'EVENT015',
  EVENT_016: 'EVENT016',
  EVENT_017: 'EVENT017',
  EVENT_018: 'EVENT018',
  EVENT_019: 'EVENT019',
  EVENT_020: 'EVENT020',
  EVENT_021: 'EVENT021',
  EVENT_022: 'EVENT022',
  EVENT_023: 'EVENT023',
  EVENT_024: 'EVENT024',
  EVENT_025: 'EVENT025',
  EVENT_026: 'EVENT026',
  EVENT_027: 'EVENT027',
  EVENT_028: 'EVENT028',
  EVENT_029: 'EVENT029',
  EVENT_030: 'EVENT030',
  EVENT_031: 'EVENT031',
  EVENT_032: 'EVENT032',
  EVENT_034: 'EVENT034',
  EVENT_035: 'EVENT035',
  EVENT_036: 'EVENT036',
  EVENT_037: 'EVENT037',
  EVENT_038: 'EVENT038',
  EVENT_039: 'EVENT039',
  EVENT_040: 'EVENT040',
  EVENT_041: 'EVENT041',
  EVENT_042: 'EVENT042',
  EVENT_043: 'EVENT043',
  EVENT_044: 'EVENT044',
  EVENT_046: 'EVENT046',
  EVENT_047: 'EVENT047',
  EVENT_048: 'EVENT048',
  EVENT_049: 'EVENT049',
  EVENT_050: 'EVENT050',
};

const EVENT_ERROR_MESSAGE = {
  [EVENT_ERROR_CODE.EVENT_001]: '기획전 식별 id는 1 이상의 정수형만 가능합니다',
  [EVENT_ERROR_CODE.EVENT_002]: '기획전 상태는 활성, 비활성, 무기한만 가능합니다',
  [EVENT_ERROR_CODE.EVENT_003]: '기획전 제목은 문자열 형식입니다',
  [EVENT_ERROR_CODE.EVENT_004]: '기획전 본문은 문자열 형태로 입력해주세요',
  [EVENT_ERROR_CODE.EVENT_005]: '기획전 메모는 문자열 형태로 입력해주세요',
  [EVENT_ERROR_CODE.EVENT_006]: '기획전 기간을 입력해주세요',
  [EVENT_ERROR_CODE.EVENT_007]: '유효하지 않은 기획전 상태입니다.',
  [EVENT_ERROR_CODE.EVENT_008]: '첨부파일의 height는 정수형만 가능합니다',
  [EVENT_ERROR_CODE.EVENT_009]: '첨부파일의 width는 정수형만 가능합니다.',
  [EVENT_ERROR_CODE.EVENT_010]: '이미지 접근 url 경로는 문자열 형식입니다.',
  [EVENT_ERROR_CODE.EVENT_011]: '유효하지 않은 기획전 상태입니다.',
  [EVENT_ERROR_CODE.EVENT_012]: '기획전 섹션 클릭 레이어 좌표는 0 이상의 Number 형식의 값만 입력이 가능합니다.',
  [EVENT_ERROR_CODE.EVENT_013]: '기획전 섹션 클릭 레이어 크기는 1 이상의 Number 형식의 값만 입력이 가능합니다',
  [EVENT_ERROR_CODE.EVENT_014]: '유효하지 않은 첨부 파일 타입입니다.',
  [EVENT_ERROR_CODE.EVENT_015]: '기획전 아이템 상품 id는 1이상의 정수형만 가능합니다.',
  [EVENT_ERROR_CODE.EVENT_016]: '기획전 태그 id는 1이상의 정수형만 가능합니다.',
  [EVENT_ERROR_CODE.EVENT_017]: '기획전 섹션 아이템 상품 id는 1이상의 정수형만 가능합니다.',
  [EVENT_ERROR_CODE.EVENT_018]: '기획전 애니메이션 시간은 0이상의 정수형만 가능합니다.',
  [EVENT_ERROR_CODE.EVENT_019]: '무한 스와이프 여부는 boolean만 가능합니다.',
  [EVENT_ERROR_CODE.EVENT_020]: '이벤트 섹션 아이템 상품 식별 id 리스트는 array 형태만 가능합니다.',
  [EVENT_ERROR_CODE.EVENT_021]: '이벤트 아이템 상품 식별 id 리스트는 array 형태만 가능합니다.',
  [EVENT_ERROR_CODE.EVENT_022]: '이벤트 태그 식별 id 리스트는 array 형태만 가능합니다.',
  [EVENT_ERROR_CODE.EVENT_023]: '유효하지 않은 기획전 섹션 첨부 파일 입니다.',
  [EVENT_ERROR_CODE.EVENT_024]: '이벤트 id는 1이상의 정수형만 가능합니다.',
  [EVENT_ERROR_CODE.EVENT_025]: '이벤트 첨부 id는 1이상의 정수형만 가능합니다.',
  [EVENT_ERROR_CODE.EVENT_026]: '이벤트 섹션 식별 id는 1이상의 정수형만 가능합니다',
  [EVENT_ERROR_CODE.EVENT_027]: '이벤트 섹션 첨부 id는 1이상의 정수형만 가능합니다.',
  [EVENT_ERROR_CODE.EVENT_028]: '이벤트 섹션 클릭 레이어 id는 1이상의 정수형만 가능합니다.',
  [EVENT_ERROR_CODE.EVENT_029]: '이벤트 섹션 아이템 id는 1이상의 정수형만 가능합니다',
  [EVENT_ERROR_CODE.EVENT_030]: '이벤트 아이템 id는 1이상의 정수형만 가능합니다.',
  [EVENT_ERROR_CODE.EVENT_031]: '이벤트 태그 링크 id는 1이상의 정수형만 가능합니다.',
  [EVENT_ERROR_CODE.EVENT_032]: '존재하지 않는 기획전입니다',
  [EVENT_ERROR_CODE.EVENT_034]: '이벤트 첨부 리스트는 배열 형태만 입력 가능합니다',
  [EVENT_ERROR_CODE.EVENT_035]: '이벤트 섹션 리스트는 배열 형태만 입력 가능합니다.',
  [EVENT_ERROR_CODE.EVENT_036]: '이벤트 아이템 리스트는 배열 형태만 입력 가능합니다.',
  [EVENT_ERROR_CODE.EVENT_037]: '이벤트 태그 링크 리스트는 배열 형태만 입력 가능합니다.',
  [EVENT_ERROR_CODE.EVENT_038]: '이벤트 섹션 첨부 리스트는 배열 형태만 입력 가능합니다.',
  [EVENT_ERROR_CODE.EVENT_039]: '이벤트 섹션 클릭 레이어 리스트는 배열 형태만 입력 가능합니다.',
  [EVENT_ERROR_CODE.EVENT_040]: '이벤트 섹션 아이템 리스트는 배열 형태만 입력 가능합니다',
  [EVENT_ERROR_CODE.EVENT_041]:
    '중복된 이벤트 첨부 식별 id가 포함되어있거나 중복 체크 property 설정 오류가 발생하였습니다.',
  [EVENT_ERROR_CODE.EVENT_042]: '중복된 섹션 아이템 상품 id가 포함되어있습니다.',
  [EVENT_ERROR_CODE.EVENT_043]: '중복된 이벤트 아이템 상품 id가 포함되어있습니다.',
  [EVENT_ERROR_CODE.EVENT_044]: '중복된 태그 id가 포함되어있습니다.',
  [EVENT_ERROR_CODE.EVENT_046]:
    '중복된 이벤트 섹션 클릭 레이어 id가 포함되어있거나 중복 체크 property 설정 오류가 발생하였습니다',
  [EVENT_ERROR_CODE.EVENT_047]:
    '중복된 이벤트 섹션 클릭 레이어 id가 포함되어있거나 중복 체크 property 설정 오류가 발생하였습니다',
  [EVENT_ERROR_CODE.EVENT_048]: '중복된 이벤트 태그 링크 id가 포함되어있습니다.',
  [EVENT_ERROR_CODE.EVENT_049]:
    '중복된 이벤트 섹션 첨부 id가 포함되어있거나 중복 체크 property 설정 오류가 발생하였습니다',
  [EVENT_ERROR_CODE.EVENT_050]: '중복된 섹션 아이템 id가 포함되어있거나 중복 체크 property 설정 오류가 발생하였습니다.',
};

export default EVENT_ERROR_MESSAGE;
